"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageStatusRow = exports.SettableStatuses = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var SplitButton_1 = require("SplitButton/SplitButton");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_1 = require("mobx");
var assertCheckIsExhaustive_1 = require("Utils/assertCheckIsExhaustive");
var c = (0, BemBuilder_1.default)("status-row");
var SettableStatuses;
(function (SettableStatuses) {
    SettableStatuses[SettableStatuses["All"] = 0] = "All";
    SettableStatuses[SettableStatuses["LiveDraft"] = 1] = "LiveDraft";
})(SettableStatuses || (exports.SettableStatuses = SettableStatuses = {}));
var SplitButtonPrimaryAction;
(function (SplitButtonPrimaryAction) {
    SplitButtonPrimaryAction[SplitButtonPrimaryAction["SetDraft"] = 0] = "SetDraft";
    SplitButtonPrimaryAction[SplitButtonPrimaryAction["SetLive"] = 1] = "SetLive";
    SplitButtonPrimaryAction[SplitButtonPrimaryAction["Disabled"] = 2] = "Disabled";
    SplitButtonPrimaryAction[SplitButtonPrimaryAction["Accept"] = 3] = "Accept";
    SplitButtonPrimaryAction[SplitButtonPrimaryAction["Decline"] = 4] = "Decline";
})(SplitButtonPrimaryAction || (SplitButtonPrimaryAction = {}));
var PageStatusRow = (function (_super) {
    __extends(PageStatusRow, _super);
    function PageStatusRow() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this._showTooltipWhenAcceptDisabled = false;
        _this.getOptionMenuItems = function () {
            var _a = _this.props, status = _a.status, disableManualAcceptance = _a.disableManualAcceptance, settableStatuses = _a.settableStatuses;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { disabled: Types_1.ProjectStatus.Draft === status, onClick: _this.triggerSetToStatus(Types_1.ProjectStatus.Draft) }, "Set to Draft"),
                react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { disabled: Types_1.ProjectStatus.Live === status, onClick: _this.triggerSetToStatus(Types_1.ProjectStatus.Live) }, "Set to Live"),
                settableStatuses == SettableStatuses.All && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { disabled: disableManualAcceptance || Types_1.ProjectStatus.Accepted === status, onClick: _this.triggerSetToStatus(Types_1.ProjectStatus.Accepted) },
                        react_1.default.createElement("div", { onMouseOver: function () { return _this.setShowTooltipWhenAcceptDisabled(true); }, onMouseOut: function () { return _this.setShowTooltipWhenAcceptDisabled(false); } },
                            react_1.default.createElement(kaleidoscope_1.Tooltip, { show: _this.showTooltipWhenAcceptDisabled, wrapTarget: true, content: "This page cannot be manually accepted because it has a Quote block or Accept block", size: kaleidoscope_1.TooltipSize.Large }, "Set to Accepted"))),
                    react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { disabled: Types_1.ProjectStatus.Declined === status, onClick: _this.triggerSetToStatus(Types_1.ProjectStatus.Declined) }, "Set to Declined")))));
        };
        _this.triggerSetToStatus = function (projectStatus) {
            return function () { return __awaiter(_this, void 0, void 0, function () {
                var shouldChangeStatus, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4, this.props.confirmPageStatusChange(projectStatus)];
                        case 1:
                            shouldChangeStatus = _b.sent();
                            if (!shouldChangeStatus) {
                                return [2];
                            }
                            _a = projectStatus;
                            switch (_a) {
                                case Types_1.ProjectStatus.Accepted: return [3, 2];
                                case Types_1.ProjectStatus.Declined: return [3, 4];
                                case Types_1.ProjectStatus.Draft: return [3, 6];
                                case Types_1.ProjectStatus.Live: return [3, 8];
                            }
                            return [3, 10];
                        case 2: return [4, this.setToAccepted()];
                        case 3:
                            _b.sent();
                            return [2];
                        case 4: return [4, this.setToDeclined()];
                        case 5:
                            _b.sent();
                            return [2];
                        case 6: return [4, this.setToDraft()];
                        case 7:
                            _b.sent();
                            return [2];
                        case 8: return [4, this.setToLive()];
                        case 9:
                            _b.sent();
                            return [2];
                        case 10: return [2];
                    }
                });
            }); };
        };
        _this.setToDraft = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, gotoPage, projectId, status, setStatus;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, gotoPage = _a.gotoPage, projectId = _a.projectId, status = _a.status, setStatus = _a.setStatus;
                        return [4, setStatus({ status: Types_1.ProjectStatus.Draft })];
                    case 1:
                        _b.sent();
                        if (gotoPage && status === Types_1.ProjectStatus.Declined) {
                            gotoPage("project", { id: projectId, skipLockedPageModal: true });
                        }
                        return [2];
                }
            });
        }); };
        _this.setToLive = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, gotoPage, projectId, status, setStatus, source;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, gotoPage = _a.gotoPage, projectId = _a.projectId, status = _a.status, setStatus = _a.setStatus, source = _a.source;
                        return [4, setStatus({ status: Types_1.ProjectStatus.Live }, source)];
                    case 1:
                        _b.sent();
                        if (gotoPage && status === Types_1.ProjectStatus.Declined) {
                            gotoPage("project", { id: projectId, skipLockedPageModal: true });
                        }
                        return [2];
                }
            });
        }); };
        _this.setToAccepted = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, gotoPage, projectId, setStatus;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, gotoPage = _a.gotoPage, projectId = _a.projectId, setStatus = _a.setStatus;
                        return [4, setStatus({ status: Types_1.ProjectStatus.Accepted, subStatus: Types_1.ProjectSubStatus.AcceptedManual })];
                    case 1:
                        _b.sent();
                        gotoPage("projectView", { id: projectId, skipLockedPageModal: true });
                        return [2];
                }
            });
        }); };
        _this.setToDeclined = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, gotoPage, projectId, setStatus;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, gotoPage = _a.gotoPage, projectId = _a.projectId, setStatus = _a.setStatus;
                        return [4, setStatus({ status: Types_1.ProjectStatus.Declined, subStatus: Types_1.ProjectSubStatus.DeclinedManual })];
                    case 1:
                        _b.sent();
                        gotoPage("projectView", { id: projectId, skipLockedPageModal: true });
                        return [2];
                }
            });
        }); };
        return _this;
    }
    PageStatusRow.prototype.render = function () {
        var _a;
        var statusText = this.props.hasTemplateChildren ? "blueprint" : this.props.status;
        var classes = (0, classnames_1.default)(c(), (_a = {},
            _a[c("status", "draft")] = statusText === Types_1.ProjectStatus.Draft,
            _a[c("status", "live")] = statusText === Types_1.ProjectStatus.Live,
            _a[c("status", "accepted")] = statusText === Types_1.ProjectStatus.Accepted,
            _a[c("status", "declined")] = statusText === Types_1.ProjectStatus.Declined,
            _a[c("status", "blueprint")] = statusText === "blueprint",
            _a));
        return (react_1.default.createElement("div", { className: c() },
            react_1.default.createElement("div", { className: classes },
                react_1.default.createElement(icons_1.ListMarkerCircle, { size: icons_1.IconSize.Large }),
                !this.props.hideStatus && react_1.default.createElement("div", { className: "space-inline-s" }, (0, lodash_1.startCase)(statusText) || "Draft"),
                this.props.projectValue),
            this.getSplitButton()));
    };
    Object.defineProperty(PageStatusRow.prototype, "showTooltipWhenAcceptDisabled", {
        get: function () {
            return this.props.disableManualAcceptance && this._showTooltipWhenAcceptDisabled;
        },
        enumerable: false,
        configurable: true
    });
    PageStatusRow.prototype.setShowTooltipWhenAcceptDisabled = function (isShow) {
        if (!this.props.disableManualAcceptance)
            return;
        this._showTooltipWhenAcceptDisabled = isShow;
    };
    PageStatusRow.prototype.getSplitButton = function () {
        var _a = this.props, status = _a.status, disabled = _a.disabled;
        var commonProps = {
            optionMenuItems: this.getOptionMenuItems(),
            disabled: disabled,
            autoStack: true,
        };
        switch (this.getPrimaryActionMapping(status)) {
            case SplitButtonPrimaryAction.SetDraft:
                return (react_1.default.createElement(SplitButton_1.SplitButton, __assign({ primaryButtonLabel: "Set draft", type: kaleidoscope_1.ButtonType.Secondary, onPrimaryClick: this.triggerSetToStatus(Types_1.ProjectStatus.Draft) }, commonProps)));
            case SplitButtonPrimaryAction.Decline:
                return (react_1.default.createElement(SplitButton_1.SplitButton, __assign({ primaryButtonLabel: "Decline", type: kaleidoscope_1.ButtonType.Secondary, onPrimaryClick: this.triggerSetToStatus(Types_1.ProjectStatus.Declined) }, commonProps)));
            case SplitButtonPrimaryAction.SetLive:
                return (react_1.default.createElement(SplitButton_1.SplitButton, __assign({ primaryButtonLabel: "Set live", type: kaleidoscope_1.ButtonType.Primary, onPrimaryClick: this.triggerSetToStatus(Types_1.ProjectStatus.Live) }, commonProps)));
            case SplitButtonPrimaryAction.Accept:
                return (react_1.default.createElement(SplitButton_1.SplitButton, __assign({ primaryButtonLabel: "Accept", type: kaleidoscope_1.ButtonType.Secondary, onPrimaryClick: this.triggerSetToStatus(Types_1.ProjectStatus.Accepted) }, commonProps)));
            case SplitButtonPrimaryAction.Disabled:
                return (react_1.default.createElement(kaleidoscope_1.Tooltip, { wrapTarget: true, size: kaleidoscope_1.TooltipSize.Large, content: react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "text-context-label space-stack-s" }, "page is accepted"),
                        react_1.default.createElement("p", null, "Accepted pages can\u2019t have their state changed.")) },
                    react_1.default.createElement(SplitButton_1.SplitButton, { primaryButtonLabel: "Change", optionMenuItems: null, type: kaleidoscope_1.ButtonType.Secondary, disabled: true })));
        }
    };
    PageStatusRow.prototype.getPrimaryActionMapping = function (status) {
        var _a, _b;
        var _this = this;
        var settableStatuses = this.props.settableStatuses;
        var primaryActionMapping;
        switch (settableStatuses) {
            case SettableStatuses.All:
                primaryActionMapping = (_a = {},
                    _a[Types_1.ProjectStatus.Draft] = function () { return SplitButtonPrimaryAction.SetLive; },
                    _a[Types_1.ProjectStatus.Declined] = function () { return SplitButtonPrimaryAction.SetLive; },
                    _a[Types_1.ProjectStatus.Live] = function () {
                        if (_this.props.disableManualAcceptance && Types_1.ProjectStatus.Declined) {
                            return SplitButtonPrimaryAction.Decline;
                        }
                        return SplitButtonPrimaryAction.Accept;
                    },
                    _a[Types_1.ProjectStatus.Accepted] = function () { return SplitButtonPrimaryAction.Disabled; },
                    _a);
                break;
            case SettableStatuses.LiveDraft:
                primaryActionMapping = (_b = {},
                    _b[Types_1.ProjectStatus.Live] = function () { return SplitButtonPrimaryAction.SetDraft; },
                    _b[Types_1.ProjectStatus.Draft] = function () { return SplitButtonPrimaryAction.SetLive; },
                    _b);
                break;
            default:
                (0, assertCheckIsExhaustive_1.assertCheckIsExhaustive)(settableStatuses);
        }
        return primaryActionMapping[status]();
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], PageStatusRow.prototype, "_showTooltipWhenAcceptDisabled", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], PageStatusRow.prototype, "showTooltipWhenAcceptDisabled", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PageStatusRow.prototype, "setShowTooltipWhenAcceptDisabled", null);
    PageStatusRow = __decorate([
        mobx_react_1.observer
    ], PageStatusRow);
    return PageStatusRow;
}(react_1.default.Component));
exports.PageStatusRow = PageStatusRow;
